import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import Dropdown from "../../components/dropdown";
import { FlatButton } from "../../components/buttons";

import Logo from "../../assets/images/header-logo.svg";
import { ADMIN, SUPERADMIN } from "../../constants/roles";
import { LOGOUT_REQ, SAVE_TO_LOCAL } from "../../actions";
import { useState } from "react";
import { Popup } from "../../components/pop-up";
import { ACL } from "../../components/acl";
import { UserAvatar } from "../../components/user_avatar";

function Header() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [confirmModal, setConfirmModal] = useState();

  let currentPathStyle = (path) =>
    location.pathname.includes(path)
      ? "text-white rounded-md bg-white bg-opacity-20"
      : "text-gray-100 rounded-md bg-white bg-opacity-0";

  const getLinkWithParams = (basePath, moduleName) => {
    try {
      const isSameModule = location.pathname.includes(basePath);
      if (isSameModule) {
        const savedParams = JSON.parse(localStorage.getItem(`dt_params_${moduleName}`));
        const page = savedParams?.page;
        if (page) {
          return `${basePath}?page=${page}`;
        }
      } else {
        return `${basePath}?page=1`;
      }
    } catch (e) {}
    return basePath;
  };

  const clearPageFromPagination = () => {
    try {
      const modules = ['Customers', 'Coworkers', 'Migrations'];
      modules.forEach(moduleName => {
        const storageKey = `dt_params_${moduleName}`;
        const savedParams = localStorage.getItem(storageKey);
        if (savedParams) {
          const params = JSON.parse(savedParams);
          delete params.page;
          localStorage.setItem(storageKey, JSON.stringify(params));
        }
      });
      setSearchParams({});
    } catch (e) {
      console.error('Error clearing page from pagination data:', e);
    }
  };

  const regions = JSON.parse(localStorage.getItem("regions"));

  const [region, setRegion] = useState(
    regions
      ? regions?.find(
          (_r) => _r.dc_name === localStorage.getItem("region_code")
        ) || regions[0]
      : {}
  );

  const refresh = () => {
    clearPageFromPagination();
    location.pathname.includes("customers") ? navigate("/") : navigate(0);
  };

  return (
    <header
      className="bg-gradient-to-r from-gray-800 to-gray-700 pb-24"
      x-data="Components.popover({ open: false, focus: true })"
      x-init="init()"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:max-w-[86rem] lg:px-8">
        <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
          {/* <div className="absolute left-0 flex-shrink-0 py-5 lg:static">
            <Link>
              <span className="sr-only">Zuper</span>
              </Link>
            </div> */}
          <div class="absolute left-0 flex-shrink-0 py-5 lg:static">
            <Link to="/">
              <span class="sr-only">Zuper</span>
              <img className="w-auto" src={Logo} alt="" />
            </Link>
          </div>
          <div className="hidden lg:ml-4 lg:flex lg:items-center lg:py-4 lg:pr-0.5">
            <div>
              <Dropdown
                trigger={
                  <FlatButton
                    appearance="custom"
                    type="button"
                    className="w-[150px] inline-flex justify-between items-center text-lg font-semibold leading-6 text-white bg-none border-none"
                    aria-expanded="false"
                  >
                    <span>{region.dc_name}</span>
                    <svg
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </FlatButton>
                }
                items={regions?.map((_region) => (
                  <p
                    className="group cursor-pointer p-3 hover:bg-gray-200/50  relative flex gap-x-6 rounded-lg"
                    onClick={() => {
                      setRegion(_region);
                      dispatch(
                        SAVE_TO_LOCAL([["region_code", _region.dc_name]])
                      );
                      refresh();
                    }}
                  >
                    {_region.dc_name}
                  </p>
                ))}
              />
            </div>
            <div className="relative ml-2 flex-shrink-0">
              <div className="[&_.menu-panel]:-left-10">
                <Dropdown
                  trigger={<UserAvatar />}
                  items={[
                    <span
                      className="group cursor-pointer hover:bg-gray-200/50 p-3 items-center  relative flex gap-x-2 rounded-lg"
                      onClick={() => {
                        setConfirmModal("pop-up");
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                        />
                      </svg>
                      <p>Logout</p>
                    </span>,
                  ]}
                />
              </div>
              <div
                className="absolute -right-2 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
                tabIndex="-1"
                style={{ display: "none" }}
              >
                <Link
                  className="block px-4 py-2 text-sm text-gray-700"
                  role="menuitem"
                  tabIndex="-1"
                  id="user-menu-item-0"
                >
                  Your Profile
                </Link>
                <Link
                  className="block px-4 py-2 text-sm text-gray-700"
                  role="menuitem"
                  tabIndex="-1"
                  id="user-menu-item-1"
                >
                  Settings
                </Link>
                <Link
                  className="block px-4 py-2 text-sm text-gray-700"
                  role="menuitem"
                  tabIndex="-1"
                  id="user-menu-item-2"
                >
                  Sign out
                </Link>
              </div>
            </div>
          </div>

          <div className="w-full py-5 lg:border-t lg:border-white lg:border-opacity-20">
            <div className="lg:grid lg:grid-cols-3 lg:items-center lg:gap-8">
              <div className="hidden lg:col-span-2 lg:block">
                <nav className="flex space-x-4">
                  {/* <Link className=" px-3 py-2 text-sm font-medium hover:bg-opacity-10" aria-current="page">Home</Link> */}
                  <Link
                    to={getLinkWithParams("/customers", "Customers")}
                    className={`${currentPathStyle(
                      "/customers"
                    )} px-3 py-2 text-sm font-medium hover:bg-opacity-10`}
                  >
                    Customers
                  </Link>
                  <ACL showFor={[ADMIN, SUPERADMIN]}>
                    <Link
                      to={getLinkWithParams("/coworkers", "Coworkers")}
                      className={`${currentPathStyle(
                        "/coworkers"
                      )} px-3 py-2 text-sm font-medium hover:bg-opacity-10`}
                    >
                      Co-workers
                    </Link>
                  </ACL>
                  {/* <Link className=" px-3 py-2 text-sm font-medium hover:bg-opacity-10">Resources</Link> */}
                  <ACL showFor={[ADMIN, SUPERADMIN]}>
                    <Link
                      to={getLinkWithParams("/migration", "Migrations")}
                      className={`${currentPathStyle(
                        "/migration"
                      )} px-3 py-2 text-sm font-medium hover:bg-opacity-10`}
                    >
                      Migration
                    </Link>
                  </ACL>
                 
                  <Link
                    to="/settings"
                    className={`${currentPathStyle(
                      "/settings"
                    )} px-3 py-2 text-sm font-medium hover:bg-opacity-10`}
                  >
                    Settings
                  </Link>
                </nav>
              </div>
              {/* <div className="px-12 lg:px-0">
                  <div className="mx-auto w-full max-w-xs lg:max-w-md">
                    <label for="search" className="sr-only">Search</label>
                    <div className="relative text-white focus-within:text-gray-600">
                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd"></path>
                        </svg>
                      </div>
                      <input id="search" className="block w-full rounded-md border-0 bg-white/20 py-1.5 pl-10 pr-3 text-white placeholder:text-white focus:bg-white focus:text-gray-900 focus:ring-0 focus:placeholder:text-gray-500 sm:text-sm sm:leading-6" placeholder="Search" type="search" name="search" />
                    </div>
                  </div>
                </div> */}
            </div>
          </div>
          <div className="absolute right-0 flex-shrink-0 lg:hidden">
            <button
              type="button"
              className="relative inline-flex items-center justify-center rounded-md bg-transparent p-2 text-cyan-200 hover:bg-white hover:bg-opacity-10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
            >
              <span className="absolute -inset-0.5"></span>
              <span className="sr-only">Open main menu</span>
              <svg
                className="block h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                ></path>
              </svg>
              <svg
                className="hidden h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="lg:hidden">
        <div
          className="fixed inset-0 z-20 bg-black bg-opacity-25"
          style={{ display: "none" }}
        ></div>
        <div
          x-show="open"
          className="absolute inset-x-0 top-0 z-30 mx-auto w-full max-w-3xl origin-top transform p-2 transition"
          x-ref="panel"
          style={{ display: "none" }}
        >
          <div className="divide-y divide-gray-200 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="pb-2 pt-3">
              <div className="flex items-center justify-between px-4">
                <div>
                  <img
                    className="h-8 w-auto"
                    src={
                      "https://tailwindui.com/img/logos/mark.svg?color=cyan&amp;shade=600"
                    }
                    alt="Your Company"
                  />
                </div>
                <div className="-mr-2">
                  <button
                    type="button"
                    className="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500"
                  >
                    <span className="absolute -inset-0.5"></span>
                    <span className="sr-only">Close menu</span>
                    <svg
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="mt-3 space-y-1 px-2">
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Home
                </Link>
                <Link
                  to={getLinkWithParams("/customers", "Customers")}
                  className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800"
                >
                  Profile
                </Link>
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Resources
                </Link>
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Company Directory
                </Link>
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Openings
                </Link>
              </div>
            </div>
            <div className="pb-2 pt-4">
              <div className="flex items-center px-5">
                <div className="flex-shrink-0">
                  <img
                    className="h-10 w-10 rounded-full"
                    src={
                      "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80"
                    }
                    alt=""
                  />
                </div>
                <div className="ml-3 min-w-0 flex-1">
                  <div className="truncate text-base font-medium text-gray-800">
                    Chelsea Hagon
                  </div>
                  <div className="truncate text-sm font-medium text-gray-500">
                    chelsea.hagon@example.com
                  </div>
                </div>
                <button
                  type="button"
                  className="relative ml-auto flex-shrink-0 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                >
                  <span className="absolute -inset-1.5"></span>
                  <span className="sr-only">View notifications</span>
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="mt-3 space-y-1 px-2">
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Your Profile
                </Link>
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Settings
                </Link>
                <Link className="block rounded-md px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-800">
                  Sign out
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup
        modalState={[confirmModal, setConfirmModal]}
        onConfirm={() => {
          dispatch(LOGOUT_REQ({}));
        }}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to logout?
            </h3>
          </>
        }
      />
    </header>
  );
}

export default Header;
